import React, { useEffect } from 'react';
import { useHistory } from 'src/services/useHistory';
import { Helmet } from 'react-helmet-async';

import { isMobileDevice } from 'src/lib/userAgent';
import { ROUTES } from 'src/routes';
import MobileDevicePage from './MobileDevicePage';
import { MobileNavBar } from './views/MobileNavBar';

const Container = () => {
  const history = useHistory();

  useEffect(() => {
    if (!isMobileDevice()) {
      history.replace(ROUTES.ROOT);
    }
  }, [history]);

  return (
    <>
      <Helmet>
        <title>Mobile</title>
      </Helmet>

      <MobileNavBar />
      <MobileDevicePage />
    </>
  );
};

export default Container;
